import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';

import ForeclosureSearchTable from './components/ForeclosureSearchTable';
import TrialAlert from '../../shared/components/payment/TrialAlert';
import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission } from '../../shared/helpers/access';
import CalloutBanner from '../../shared/components/CalloutBanner';

import { isMobile } from 'react-device-detect';

class ForeclosureSearch extends React.Component {
	render() {
		const { user } = this.props;
		if (!user) return null;

		return (
			<Container>
				<Row>
					<Col md={12}>
						<h3 className="page-title">Foreclosure Search</h3>
						{!isMobile && (
							<h3 className="page-subhead subhead">
								Find properties in foreclosure, scheduled for auction, or carrying distress liens
							</h3>
						)}
					</Col>
				</Row>
				{_hasPermission(user, 'owner-outreach') ? (
					<Fragment>
						<Row>
							<Col md={12} className={'mb-3'}>
								<TrialAlert />
							</Col>
						</Row>

						<CalloutBanner storageKey="mp_foreclosure_search_banner_v1" variant="purple">
							{function () {
								return (
									<div className="d-flex justify-content-between align-items-center flex-wrap">
										<div>
											<p className="callout-banner-title">
												<img
													src="https://marketproof.com/images/new-red.png"
													alt=""
													style={{ marginRight: 6 }}
												/>
												Foreclosure Search
											</p>

											<p className="callout-banner-sub-title mb-2">
												Track lis pendens filings, upcoming auctions, and distress liens across NYC.
												Drill into NYSCEF case documents and case stage progression.
											</p>
										</div>

										<div className="align-items-center mt-2 text-right">
											<a
												href="https://help.marketproof.com/en/articles/15545086-property-search-foreclosures"
												target="_blank"
												rel="noopener noreferrer"
												className="btn btn-primary mb-2 callout-banner-btn"
											>
												Learn More
											</a>
										</div>
									</div>
								);
							}}
						</CalloutBanner>

						<Row>
							<ForeclosureSearchTable />
						</Row>
					</Fragment>
				) : (
					<Row>
						<EnterpriseGate
							copy={<span>Access to Foreclosure Search requires an upgrade to your subscription.</span>}
							upgrade={true}
							user={user}
							nextPlan={'complete'}
						/>
					</Row>
				)}
			</Container>
		);
	}
}

export default connect(state => ({
	user: state.user,
}))(ForeclosureSearch);
